export const WIDTH_HEIGHT = new Set(['width', 'height']);
